export interface Deferred<T = void> {
  promise: Promise<T>
  done: (value: T) => void
}

export function createDeferred<T = void>(): Deferred<T> {
  let resolve!: (value: T) => void
  const promise = new Promise<T>((r) => {
    resolve = r
  })
  return { promise, done: resolve }
}
